import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {UserListComponent} from './user-list.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.userList.pageInRouting,
    data: {data: PAGES_AND_PATHS.userList},
    component: UserListComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./user-list.module').then(m => m.UserListModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserListRoutingModule { }
